// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__3ClsW","btns":"Chart_btns__1T58I","active":"Chart_active__prhC2","wrap":"Chart_wrap__Wq4JV","loader":"Chart_loader__GAxxI"};